import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import PropertyCreateForm from '../components/properties/PropertyCreateForm';
import SocietyContextMobileNav from '../components/societies/SocietyContextMobileNav';

const PropertyCreatePage = () => {
  const { societySlug } = useParams();

  return (
    <PageLayout title="PakPoints">
      <Helmet>
        <title>Create Property - PakPoints</title>
        <meta name="description" content="Create a new property listing to sell or rent on PakPoints" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {societySlug ? (
          <SocietyContextMobileNav societySlug={societySlug} activeSection="property" />
        ) : null}
        <div className="py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <PropertyCreateForm />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default PropertyCreatePage;
